__turbopack_context__.v({
  "buyNowButton": "lVfiPW_buyNowButton",
  "ctaButton": "lVfiPW_ctaButton",
  "ctaLink": "lVfiPW_ctaLink" + " " + __turbopack_context__.i(931616)["ctaStyle"],
  "flatButton": "lVfiPW_flatButton",
  "flatLink": "lVfiPW_flatLink",
  "primaryCta": "lVfiPW_primaryCta",
  "secondaryButton": "lVfiPW_secondaryButton",
  "secondaryCta": "lVfiPW_secondaryCta",
});
